import { mapGetters } from 'vuex'
import utils from '@/utils';
import { codeData } from '@/utils/codeData';

export default {
    data(){
        return{
            ...codeData
        }
    },
    computed: {
        ...mapGetters([
            'authorCode'
        ]),
    },
    methods: {
        handleCode(code) {
            // let authorCode = this.authorCode.length > 0 ? this.authorCode : window.localStorage.getItem('authorCode') ? window.localStorage.getItem('authorCode').split(','):[]
            // return utils.codeStatus(authorCode, code);
            return true
        },
    },
}